export default __webpack_public_path__ + "static/media/z020di0a.accde5f9.mp3";